export default __webpack_public_path__ + "static/pay-efe551c85166e784d229888288c55c66.png";